import { COLOR, line } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'MEDPRICE',
  version: 1,
  label: 'Median Price (HL/2)',
  pane: 'main',
  category: 'trend',
  series: 'price',
  order: 91,
  inputs: [],
  outputs: [line('medprice', 'HL/2', COLOR.blue)],
  talib: { functions: ['MEDPRICE'], expr: 'MEDPRICE(high, low)' },
  listed: true,
  tailSafe: true,
  lookback: () => 0,
}
export default def
